import { render } from "./ProcessHeader.vue?vue&type=template&id=f5e816f2&ts=true"
import script from "./ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./ProcessHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__